// extracted by mini-css-extract-plugin
export default {"container":"UuXo","goBack":"SKG1","fields":"witP"};